import React from 'react';
import styled from 'styled-components';

 const Tos: React.FC = () => {
    return (
        <StyledPrivacyContainer>
            <h1>가드너스클럽(Gardener’s Club) 이용약관</h1>
            <h3>제1장 총칙</h3>
            <h3>제1조(목적)</h3>
            <span>
                : 이 약관은 주식회사 가드너스클럽(이하 ‘회사’)가 운영하는 인터넷/모바일 플랫폼(이하 ‘가드너스클럽’)의
                서비스를 이용함에 있어 플랫폼과 “이용자”의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.
            </span>
            <h3>제2조(정의)</h3>
            <span>
                : 본 약관에서 사용하는 용어의 정의는 아래 각 호와 같습니다.
                <div /> ① 가드너스클럽: 회사가 운영하는 플랫폼으로, 재화 및 용역(이하 ‘재화 등’)의 광고를 이용자에게
                제공하거나, 파트너-이용자 간 거래를 중개하고, 회사 및 이용자의 창작물을 통한 이용자 간 상호작용을 위한
                공간으로, 나아가 플랫폼을 운영하는 사업자의 의미로도 사용합니다.
                <div /> ② 서비스: 회사 및 이용자의 창작물 및 그를 매개로 한 이용자 간 상호작용 공간, 파트너가 제공하는
                재화 등의 광고, 파트너-이용자 간 거래 중개 등 이용자의 가드닝 라이프를 지원하기 위해 회사가 플랫폼을
                통해 제공 및 제공 예정인 서비스를 통칭합니다.
                <div /> ③ 제휴 서비스: 회사의 타 서비스 혹은 협력관계의 제3자가 운영하는 서비스와 가드너스클럽의 연동등
                다양한 방식의 제휴를 통해 가드너스클럽과 별개로 이용자에 제공하는 서비스를 말합니다.
                <div />④ 이용자: 회사가 제공하는 서비스를 이용하는 자로, 회원과 비회원을 포함합니다.
                <div />⑤ 회원: 가드너스클럽에 회원등록을 마친 자로서, 플랫폼 내 서비스를 이용할 자격을 보유한 자를
                말합니다.
                <div />⑥ 비회원: 가드너스클럽에 회원가입을 하지 않고, 제한적으로 플랫폼 내 서비스를 이용하는 자를
                말합니다.
                <div />⑦ 콘텐츠: 회사 혹은 이용자가 서비스 상에 게시/등록하는 모든 글(텍스트), 사진, 동영상, 파일, 링크,
                회원 소개 등(부호, 문자, 영상, 그림 등 형태 불문) 가드너스클럽 내 게시/활용된 일체의 정보를 말합니다.
                <div />⑧ 파트너: 가드너스클럽이 요청한 일련의 절차를 마치고 가드너스클럽을 이용하는 자로서,
                가드너스클럽을 통해 이용자에게 자신의 재화 등을 광고 및 판매하는 자를 말합니다.
                <div />⑨ 회원정보: 가드너스클럽을 통해 가입을 신청한 자에게 회원가입 신청양식(이하 ‘신청양식’)에 따라
                기재를 요청하는 개인정보 및 회원의 식별과 서비스 이용을 위하여 회원이 가드너스클럽에 제공한 정보를
                말합니다.
            </span>
            <h3>제3조(약관 등의 설명 및 개정)</h3>
            <span>
                ① 가드너스클럽은 본 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자 민원을 처리할 수 있는
                주소를 포함), 전화번호, 전자우편주소, 사업자등록번호, 통신판매업신고번호 등을 이용자가 쉽게 인지할 수
                있도록 가드너스클럽 내 초기 서비스 화면(전면)에 게시합니다. 다만, 본 약관의 내용(개정시 개정 내용을
                포함)은 이용자가 연결 화면을 통해 확인할 수 있도록 게시할 수 있습니다.
                <div />② 가드너스클럽이 필요로 하는 경우, 관련법령을 위배하지 않는 범위 내의 약관 개정이 가능하며, 본
                약관을 개정할 경우 개정 필요성 및 적용 일자를 명시, 현행 약관과 함께 플랫폼 초기 화면에 적용일 7일
                전부터 적용일 전일까지 공지합니다. 다만, 가드너스클럽이 회원에게 불리한 내용으로의 약관 개정을 진행하는
                경우, 최소 30일 이상 유예 기간을 설정, 공지하며 이와 같은 경우 개정 전후 내용에 대해 회원이 이해하기
                쉽게 표시하겠습니다.
                <div />③ 가드너스클럽의 개정약관 공지 및 통지에 대해, 회원에게 일정 기한 내 의사표시가 없을 경우 동의로
                간주한다는 뜻을 명확하게 별도로 공지 및 통지하였음에도, 회원이 거부의사를 명시적으로 표시하지 아니한
                경우, 회원 이 해당 개정약관에 동의한 것으로 봅니다. 또한, 회원이 개정약관의 적용에 동의하지 않는 경우
                가드너스클럽은 해당 개정약관의 내용을 적용할 수 없으며, 이와 같은 경우 회원은 회원 탈퇴를 할 수
                있습니다. 다만, 개정 전 약관을 적용할 수 없은 특수한 사정이 있는 경우, 가드너스클럽은 해당 회원의
                회원자격을 상실시킬 수 있습니 다.
                <div />④ 가드너스클럽이 본 약관을 개정할 경우, 해당 개정약관은 그 적용일자 이후에 체결되는 계약에 한해서
                적용 되고, 개정약관 적용 전 체결된 계약에 대하서는 개정 전 약관이 그대로 적용됩니다. 다만, 회원이
                적용일자 이전 체결된 계약에 대해 개정 후 약관의 적용을 받기 원하는 의사표시를 제3항에 의한 개정약관의
                공지 기간 내에 가드너스클럽에 전달, 동의를 받은 경우에 대해서는 개정약관이 적용됩니다.
            </span>
            <h3>제4조(약관 외준칙)</h3>
            <span>
                <div /> ① 본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여는 『전자상거래 등에서의 소비자보호에
                관한 법률』, 『약관의 규제에 관한 법률』, 공정거래위원회가 정하는 『전자상거래 등에서의 소비자보호
                지침』 등 관련법령 및 상관례에 따릅니다.
                <div />② 가드너스클럽은 필요한 경우 특정 서비스에 관하여 적용될 사항(이하 '개별약관')을 정하여 이를
                가드너스클럽을 통해 미리 공지할 수 있습니다.
                <div />③ 가드너스클럽은 제2항의 개별약관에 변경이 있을 경우 본 약관 제3조 제2항에 따라 공지하도록
                하겠습니다.
            </span>
            <h3>제2장 가드너스클럽 이용방법</h3>
            <h3>제5조(회원가입)</h3>
            <span>
                ① 회원으로 가입하고자 하는 이용자는 회원정보를 기입한 후 본 약관과 개인정보수집 및 이용에 동의한다는 의
                사표시를 함으로써 회원가입을 신청할 수 있습니다.
                <div />② 가드너스클럽은 제1항과 같이 회원가입을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로
                등록합니다.
                <div />
                <StyledPrivacyContent>
                    1. 가입신청자가 만 14세 미만인 경우
                    <div />
                    2. 회원정보에 허위, 기재 누락, 오기가 있는 경우
                    <div />
                    3. 가입신청자가 본 약관 제11조에 따라 이전에 회원자격을 상실한 적이 있는 경우(다만, 본 약관 제11조에
                    의 한 회원자격 상실 후 6개월이 경과한 자로서 가드너스클럽의 회원 재가입 승낙을 얻은 경우에는 예외)
                    <div /> 4. 회원으로 등록하는 것이 기술상 현저히 곤란한 경우
                    <div />
                    5. 기타 본 약관에 위배되거나 위법 또는 부당한 이용신청임이 확인된 경우 및 가드너스클럽이 합리적인
                    판단에 의하여 필요하다고 인정하는 경우
                </StyledPrivacyContent>
                <div /> ③ 가입신청의 처리는 신청순서에 의하며, 회원가입의 완료시기는 신청에 대한 가드너스클럽의 승낙의
                의사표시가 신청자에게 도달한 시점으로 합니다.
                <div />④ 회원은 회원가입 시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 가드너스클럽에 회원정보
                수정등 의 방법으로 변경사항을 알려 가드너스클럽이 원활한 서비스를 제공할 수 있도록 조력하여야 할 의무가
                있습니다. 회원이 이러한 의무를 해태하여 서비스의 불완전제공 또는 미제공 등 불이익이 발생하는 경우라도,
                가드너스 클럽은 별도의 귀책사유가 없는 한 그에 대한 책임을 부담하지 아니합니다.
                <div />⑤ 가드너스클럽은 회원의 종류 및 등급을 구분할 수 있으며, 구분별로 이용할 수 있는 가드너스클럽의
                서비스 종류, 혜택을 세분하는 등으로 회원 간 이용에 차등을 둘 수 있습니다.
            </span>
            <h3>제6조(개인정보보호)</h3>
            <span>
                : 회사는 가드너스클럽 이용자의 개인정보를 소중하게 생각합니다. 회사는 관련법령에 따른 허용범위 및 이용자
                의 동의 내에서, 서비스의 원활한 제공을 위하여 필요한 범위로만 이용자의 개인정보를 처리합니다. 회사가
                가드 너스클럽 이용자의 개인정보를 안전하게 처리하기 위하여 기울이는 노력 기타 관련한 상세한 내용은
                개인정보처리방침을 확인하여 주시기 바랍니다.
            </span>
            <h3> 제7조(ID 및 비밀번호 관리)</h3>
            <span>
                ① 회원의 ID 및 비밀번호는 회원 본인만 이용할 수 있습니다. 회원은 다른 사람이 자신의 ID 및 비밀번호를 이
                용하도록 허락하여서는 아니되며, 다른 사람이 자신의 ID 및 비밀번호를 무단으로 사용할 수 없도록 관리하여야
                합니다.
                <div />② 회원의 과실로 인한 ID 또는 비밀번호의 유출, 기타 본 약관에 반하여 이루어진 회원의 ID 또는
                비밀번호에 대한 양도, 대여 행위로 인하여 발생하는 손실이나 손해에 대하여는 가드너스클럽의 귀책사유가
                없는 한 회원 본인이 전적으로 책임을 부담하오니 유의하여 주시기 바랍니다.
                <div />③ 가드너스클럽은 회원 ID의 유출 우려가 있거나, ID에 반사회적 또는 미풍양속에 어긋나는 표현이
                포함되어 있는 경우, 기타 이용자를 회사 및 가드너스클럽의 운영자로 오인할 우려가 있는 경우에는 사전예고
                없이 본 약관 제11조 제4항에 따라 회원자격을 제한하거나 해당 ID의 이용을 제한할 수 있습니다.
                <div />④ 회원은 자신의 ID 및 비밀번호를 도난당하거나, 무단 사용을 발견하면, 이를 즉시 가드너스클럽에
                통보하여야 하며, 가드너스클럽은 통보를 받은 즉시 회원의 정보를 보호하기 위하여 필요한 최선의 노력을 다할
                것입니다.
            </span>
            <h3>제8조(통지 및 공지)</h3>
            <span>
                : 가드너스클럽은 이용자와의 의사소통을 무엇보다 우선시합니다.
                <div />① 이용자는 언제든지 고객센터 또는 고객의 소리를 방문하여 서비스와 관련한 의견을 전달할 수
                있습니다.
                <div />② 가드너스클럽의 회원에 대한 통지는 회원정보에 기재된 E-mail 주소로의 발송 또는 휴대폰 번호로
                알림톡을 보내는 등 전자적 방법으로 이뤄지며, 이러한 전자적 통지가 회원에 도달한 때에 효력이 발생합니다.
                <div />③ 가드너스클럽이 불특정 다수의 회원에게 통지를 하는 경우 1주일 이상 가드너스클럽에 게시하는
                방법으로 제 2호의 개별 통지를 대신할 수 있습니다. 다만, 특정 회원의 거래와 관련하여 중대한 영향을 미치는
                사항에 대하여는 해당 회원에게 개별적으로 통지하는 것을 원칙으로 합니다.
                <div />④ 가드너스클럽이 비회원에 대한 통지를 할 경우 본 약관에 별도 규정이 없는 한 이용자가 제공한
                E-mail, 휴대폰 번호 등으로 통지할 수 있으며, 불특정 다수의 비회원에게 통지하는 경우 제3호에 따라 통지할
                수 있습니다.
            </span>
            <h3>제9조(쿠폰)</h3>
            <span>
                ① 가드너스클럽은 회원의 재화 등의 구매, 이벤트 참여 등 일정한 서비스 이용을 조건으로 가드너스클럽 내 별
                도 안내페이지 등에서 고지한 바에 따라 회원에게 재화 등의 구매시 일정액 또는 일정비율을 할인 받을 수 있
                는 쿠폰을 부여할 수 있습니다.
                <div />② 쿠폰의 부여 방법 및 사용 기간 등 쿠폰과 관련한 상세한 내용은 가드너스클럽 내 별도 안내페이지
                등의 기재에 따릅니다.
                <div />③ 회원은 본인의 거래에 대해서만 쿠폰을 사용할 수 있으며, 어떠한 경우라도 쿠폰을 타인에게 매매
                또는 양도 하거나, 실질적으로 매매 또는 양도와 동일하게 볼 수 있는 행위를 하여서는 아니됩니다.
                <div />④ 쿠폰은 명시된 조건 및 사용 기간 내에서만 사용할 수 있습니다.
                <div />⑤ 가드너스클럽은 파트너, 재화 등의 종류, 거래금액 등 다양한 조건에 따라 쿠폰의 사용을 제한할 수
                있으며, 회원을 탈퇴한 경우 쿠폰은 소멸됩니다.
                <div />⑥ 부정한 방법으로 쿠폰을 획득한 사실이 확인될 경우 가드너스클럽은 회원에게 이를 통지하고
                소명기회를 부여한 뒤 쿠폰의 회수 또는 형사 고발 등 필요한 조치를 취할 수 있습니다.
            </span>
            <h3>제10조(포인트)</h3>
            <span>
                ① 가드너스클럽은 회원의 재화 등의 구매, 리뷰 작성, 각종 이벤트 참여 등 일정한 서비스 이용을 조건으로, 가
                드너스클럽 내 별도 안내페이지의 기재에 따라 회원에게 가드너스클럽에서 사용할 수 있는 포인트를 지급할 수
                있습니다.
                <div />② 1포인트는 가드너스클럽 내에서 원화 1원과 같은 가치를 가지며, 회원은 가드너스클럽이 정한 조건에
                따라 서비스 이용 과정에서 포인트를 단독으로 또는 다른 결제 수단과 함께 사용할 수 있습니다.
                <div />③ 포인트의 부여 및 사용에 관한 조건 등 관련한 상세 내용은 가드너스클럽이 정한 정책에 따르되,
                가드너스클럽은 별도 안내페이지 등을 통하여 포인트와 관련한 상세한 내용을 회원에게 안내합니다.
                <div />④ 포인트의 유효기간은 지급일로부터 1년이며 유효기간이 지나면 자동적으로 소멸하는 것을 원칙으로
                합니다. 다만, 가드너스클럽은 포인트 별로 상이한 유효기간을 정하여 회원에게 부여할 수 있고, 이 경우
                포인트 관련 안 내페이지에서 그를 안내하도록 하겠습니다.
                <div />⑤ 포인트는 유효기간의 만료일이 빠른 순서로 사용되며 회원을 탈퇴하면 미사용한 포인트는 소멸됩니다.
                <div />⑥ 회원은 포인트를 본인의 거래에 대해서만 사용할 수 있으며, 어떠한 경우라도 포인트를 타인에게 매매
                또는 양도하거나, 실질적으로 매매 또는 양도와 동일하게 볼 수 있는 행위를 하여서는 아니됩니다.
                <div />⑦ 부정한 방법으로 포인트를 획득한 사실이 확인될 경우 가드너스클럽은 회원에게 이를 통지하고
                소명기회를 부여한 뒤 포인트 회수 또는 형사 고발 등 필요한 조치를 취할 수 있습니다.
                <div />⑧ 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 가드너스클럽이 더 이상 서비스를 제공할
                수 없게 되는 경우, 가드너스클럽은 본 약관 제8조에 정한 방법으로 회원에게 통지하고 서비스 종료시점을
                기준으로 각 회원들이 보유한 포인트를 제2항 기재 가치에 상응하는 현물 또는 현금으로 회원에게 지급하도록
                하겠습니다.
            </span>
            <h3>제 11 조 (회원탈퇴 등)</h3>
            <span>
                ① 회원이 더 이상 가드너스클럽 이용을 원치 않는 때에는 언제든지 가드너스클럽을 통하여 탈퇴를 요청할 수 있
                으며, 회사는 즉시 탈퇴 조치합니다. 단, 회원탈퇴로 인해 발생하는 불이익은 회원 본인이 부담하여야 하며,
                탈퇴 처리가 완료되면 가드너스클럽이 회원에게 부가적으로 제공한 각종 혜택이 소멸 또는 회수될 수 있으니
                신중하게 탈퇴 요청하여 주시기 바랍니다.
                <div />② 회원의 탈퇴 처리가 완료된 경우 이용자가 게시한 콘텐츠는 본 약관 제23조 제7항에 따라 처리됩니다.
                <div />③ 탈퇴한 회원이 다시 한번 가드너스클럽 이용을 희망할 경우, 회사는 그를 거절할 수 있으며 소정의
                기준에 따라 서비스의 재이용을 허락할 수 있습니다.
                <div />④ 회원이 다음 각 호의 사유에 해당하는 경우 가드너스클럽은 부득이하게 회원자격을 제한 및
                상실시키거나 재 이용에 제한을 둘 수 있습니다.
                <div />
                <StyledPrivacyContent>
                    1. 회원이 사망한 경우
                    <div />
                    2. 서비스 이용과 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우
                    <div />
                    3. 제5조 2항의 승낙거부사유가 있음이 확인된 경우
                    <div />
                    4. 제7조 제3항의 ID 이용제한 사유가 있음이 확인된 경우
                    <div />
                    5. 회원 자신 또는 제3자의 ID를 이용하여 직접 소비하기 위한 의사 없이 재판매 등 상업적/영리적
                    목적으로 재화 등을 구매하거나, 그와 같은 사정이 합리적으로 의심되는 경우
                    <div />
                    6. 가드너스클럽에 게시된 각종 콘텐츠 기타 자료를 무단으로 수집하여 복제, 송신, 출판, 배포, 방송,
                    기타 방 법에 의하여 영리적 목적으로 유용하거나 제3자에게 유용하게 하는 경우
                    <div />
                    7. 회사가 제공하는 서비스 이용방법을 따르지 않고 매크로, 다수 생성 ID 사용 등 비정상적인 방법을 통해
                    서비스를 이용(어뷰징)하거나 시스템에 접근하는 경우
                    <div />
                    8. 가드너스클럽 및 기타 제3자의 저작권 등 지식재산권에 대한 침해행위가 확인된 경우
                    <div />
                    9. 가드너스클럽 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위가 확인된 경우
                    <div />
                    10. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보 및 성별, 종교, 장애, 연령
                    등을 차별하거나 이에 대한 편견을 조장하는 내용 등 본 약관 제22조 제1항 각 호에 해당하는 행위가
                    확인된 경우
                    <div />
                    11. 본 약관 또는 개별약관을 위반한 경우
                    <div />
                    12. 기타 회원의 불법행위 등 가드너스클럽이 서비스 제공을 거부할 필요가 있다고 인정하는 경우
                </StyledPrivacyContent>
                <div />⑤ 가드너스클럽이 회원자격을 상실시키는 경우에는 회원 등록을 말소합니다. 이 경우 회원에게 이를
                통지하고, 회원 등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.
                <div />⑥ 본 조에 의하여 가드너스클럽이 회원자격을 상실시키더라도, 상실 이전에 이용한 서비스와
                관련하여서는 본 약관이 적용됩니다.
            </span>
            <h3>제3장 가드너스클럽 서비스</h3>
            <h3>제12조(가드너스클럽 서비스 제공)</h3>
            <span>
                ① 가드너스클럽은 이용자를 위해 다음과 같은 서비스를 제공합니다.
                <div />
                <StyledPrivacyContent>
                    1. 파트너가 제공하는 재화 등의 광고, 계약체결 지원 등 파트너-고객 간 거래 중개와 관련 일체의 서비스
                    <div />
                    2. 회사 및 이용자의 창작물을 게시하고, 관련한 이용자 간 상호활동 등을 지원하기 위한 운영서비스
                    <div />
                    3. 기타 이용자를 위하여 제공하는 서비스
                </StyledPrivacyContent>
                <div />② 가드너스클럽 서비스에 관하여 기존 내용을 재화 등의 품절 및 기술사양 변경 등의 사유로 수정,
                변경할 경우에는 해당 사유를 이용자에게 본 약관 제8조에서 정한 방법 등으로 신속히 통지하겠습니다.
            </span>
            <h3>제13조(서비스 중단)</h3>
            <span>
                ① 가드너스클럽은 365일 쉬지 않고 이용자에게 서비스를 제공하기 위하여 최선의 노력을 다합니다. 다만, 아래
                각 호의 경우에는 부득이하게 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.
                <div />
                <StyledPrivacyContent>
                    1.PC 등 정보통신설비의 보수 점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우
                    <div />
                    2. 파트너와의 계약종료 등 가드너스클럽의 제반사정으로 서비스를 유지할 수 없는 경우
                    <div />
                    3. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 발생한 경우
                </StyledPrivacyContent>
                <div />② 가드너스클럽은 제1항의 사유로 서비스의 제공이 제한 또는 중단되는 경우 이용자 또는 제3자가 입은
                손해에 대하여 배상합니다. 다만, 가드너스클럽이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지
                아니합니다.
            </span>
            <h3>제14조(정보 제공 및 광고 게재)</h3>
            <span>
                ① 가드너스클럽은 서비스를 운영함에 있어 다양한 정보를 가드너스클럽 내 지정하는 위치에 게시하거나 본 약
                관 제8조에서 정한 방법 등으로 이용자에게 제공할 수 있습니다. 단, 상업적 광고는 사전에 광고수신 여부 및
                수 신방법에 별도로 동의한 이용자에 한정하여 제공합니다. 그리고 이용자는 가드너스클럽에게 법령에 따라
                부과된 의무이행과 관련한 절차안내, 고객문의 등에 대한 답변, 기타 거래관련 정보 등을 제외하고는 언제든지
                가드너스클럽이 제공하는 정보의 수신을 거부할 수 있습니다.
                <div />② 가드너스클럽은 파트너가 게시한 광고를 전달하고 매개하는 역할을 할 뿐이며, 이용자가 해당 광고를
                이용하거나 판촉활동에 참여하는 등의 경우 달리 귀책사유가 없는 한 가드너스클럽은 이에 대해 일체의 책임을
                지지 않으니 유의하여 주시기 바랍니다.
            </span>
            <h3>제1절 스토어 서비스</h3>
            <span>
                : 스토어에서는 다양한 파트너의 재화 등이 광고 또는 판매되고 있으며, 가드너스클럽은 통신판매중개인으로서
                파트너와 이용자 간 거래를 중개합니다.
            </span>
            <h3>제15조(통신판매중개서비스 이용)</h3>
            <span>
                ① 가드너스클럽은 통신판매중개자로서 이용자와 파트너 간의 자유로운 재화 등의 거래를 위한 시스템을 운영 및
                관리, 제공할 뿐이므로, 거래당사자가 아니며 이에 따라 거래와 관련된 일체의 책임을 부담하지 아니합니다.
                <div />② 이용자는 재화 등을 구매할 경우에는 본인 명의의 결제수단을 사용하여야 하고, 타인의 결제수단을
                임의로 사용하여서는 아니되며, 타인의 결제수단을 임의로 사용하여 가드너스클럽, 파트너 및 해당 결제수단
                소유자에게 손실 또는 손해가 발생할 경우 가드너스클럽의 귀책사유가 없는 한 이에 대한 모든 책임을
                부담하오니 유의하여 주시기 바랍니다.
                <div />③ 가드너스클럽은 이용자가 파트너와의 계약 절차에서 분쟁이 발생하면 분쟁의 해결을 위하여 최선을
                다하며, 이용자의 피해 구제 신청이 있는 경우에는 공정거래위원회 또는 시도지사가 의뢰하는 분쟁조정기관의
                조정에 따를 수 있습니다.
            </span>
            <h3>제16조(매매계약 체결 등)</h3>
            <span>
                ① 재화 등의 매매계약은 이용자가 파트너가 제시한 재화 등의 판매 조건에 응하여 청약의 의사표시를 하고 이
                에 대하여 파트너가 승낙의 의사표시를 함으로써 체결됩니다.
                <div />② 가드너스클럽은 이용자가 현금, 카드 기타의 방법으로 대금을 결제할 수 있는 방법을 제공합니다.
                <div />③ 대금의 결제와 관련하여 이용자가 입력한 정보 및 그와 관련하여 발생한 책임과 불이익은
                가드너스클럽의 귀책사유가 없는 한 전적으로 이용자가 부담하오니 유의하여 주시기 바랍니다.
                <div />④ 가드너스클럽은 이용자의 재화 등 매매계약 체결 내용을 나의 쇼핑 내역을 통해 확인할 수 있도록
                조치하며, 계약의 취소 방법 및 절차를 안내합니다.
                <div />⑤ 가드너스클럽은 이용자가 대금 결제 시 사용한 결제수단에 대해 정당한 사용권한을 가지고 있는지의
                여부를 확인할 수 있으며, 이에 대한 확인이 완료될 때까지 거래 진행을 중지하거나 확인이 불가한 경우 해당
                거래를 취소할 수 있습니다.
                <div />⑥ 미성년자인 이용자가 서비스를 이용하여 재화 등을 구매하는 경우에 법정대리인이 해당 계약에 대하여
                동의 하지 아니하면 미성년자인 이용자 본인 또는 법정대리인은 그 계약을 취소할 수 있습니다.
                <div />⑦ 이용자가 실제로 결제하는 금액은 파트너가 정한 공급원가, 기본이용료, 상품에 적용된 할인쿠폰,
                배송비, 옵션상품의 옵션내역 등이 적용된 금액(실구매액)이며 구매자에게 발행되는 구매증빙서(현금영수증,
                세금계산서, 신 용카드매출전표 등)는 실구매액으로 발행됩니다.
            </span>
            <h3>제17조(결제 대금 예치 등)</h3>
            <span>
                ① 가드너스클럽은 선지급식 통신판매에 있어서 이용자가 지급하는 결제대금을 예치하고 배송이 완료된 후 재화
                또는 용역의 대금을 파트너에게 지급하거나 파트너에게 결제대금을 지급하기 이전에 이용자가 취소, 반품, 교환
                또는 환불의 의사를 표시한 경우에는 그 지급을 보류함으로써 이용자의 안전을 도모합니다.
                <div />② 가드너스클럽은 이용자에게 재화 등을 공급받은 사실을 재화 등을 공급받은 날(배송완료일)로부터
                3영업일 이내에 통보하여 주도록 요청합니다.
            </span>
            <h3>제18조(배송 및 거래완료)</h3>
            <span>
                ① 가드너스클럽은 파트너와 이용자 간의 배송과 관련하여 파트너, 이용자, 배송업체 등 관련 당사자 사이에 발
                생한 분쟁 등에 대해 관련법령에 따라 법률상 책임을 지는 경우 외에는 관여하지 않으며 어떠한 책임도 부담하
                지 아니합니다. 이 경우 해당 분쟁 등은 관련 당사자가 직접 해결하여야 합니다.
                <div />② 이용자는 구매한 재화 등의 배송이 완료되었을 때부터 7일 이내에 가드너스클럽에 대하여 구매확정,
                교환 또는 반품의 의사표시를 할 수 있습니다.
                <div />③ 가드너스클럽은 제2항의 기간 내에 구매확정, 교환 또는 반품에 대한 이용자의 의사표시가 없는 경우,
                해당 거래에 대하여 자동구매확정으로 처리할 수 있습니다.
                <div />④ 구매확정 이후에 발생하는 환불, 교환 기타 파트너와 이용자 간의 모든 문제는 거래 당사자인
                파트너와 이용자가 직접 해결해야 하며, 가드너스클럽은 이에 개입하지 아니합니다.
            </span>
            <h3>제19조(청약철회 등)</h3>
            <span>
                ① 파트너와 재화 등의 구매에 관한 계약을 체결한 이용자(이하 '구매자')는 『전자상거래 등에서의 소비자
                보호에 관한 법률』 제13조 제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의
                공급이 늦게 이루어진 경우에는 재화 등을 공급받거나 재화 등의 공급이 시작된 날을 말함)부터 7일 이내에는
                청약을 철회할 수 있습니다. 다만, 청약철회에 관하여 『전자상거래 등에서의 소비자 보호에 관한 법률』에
                달리 정함이 있는 경우에는 동 법 규정에 따릅니다.
                <div />② 구매자는 재화 등을 배송 받고 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.
                <div />
                <StyledPrivacyContent>
                    1. 구매자에게 책임이 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만 재화 등의 내용을 확인하기
                    위하여 포장 등을 훼손한 경우는 제외)
                    <div />
                    2. 구매자의 사용 또는 일부 소비로 재화 등의 가치가 현저히 감소한 경우
                    <div />
                    3. 시간이 지나 다시 판매하기 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우
                    <div />
                    4. 복제가 가능한 재화 등의 포장을 훼손한 경우
                    <div />
                    5. 용역 또는 『문화산업진흥 기본법』 제2조제5호의 디지털콘텐츠의 제공이 개시된 경우(다만, 가분적
                    용역 또는 가분적 디지털콘텐츠로 구성된 계약의 경우에는 제공이 개시되지 아니한 부분에 대하여는 제외)
                    <div />
                    6. 주문에 따라 개별적으로 생산되는 재화 등 그에 대하여 청약철회 등을 인정할 경우 파트너에게 회복할
                    수 없는 중대한 피해가 예상되는 경우로서, 사전에 해당 거래에 대하여 별도로 그 사실을 고지하고
                    구매자의 서면(전자문서를 포함)에 의한 동의를 받은 경우
                    <div />
                    7. 그 밖에 관련법령에 따른 반품 및 교환 제한 사유에 해당되는 경우
                </StyledPrivacyContent>
                <div />③ 제2항 제2호 내지 제4호의 경우에는 파트너가 사전에 청약 철회 등이 제한되는 사실을 구매자가 쉽게
                알 수 있는 곳에 명기하거나 사용 상품을 제공하는 등의 조치를 하지 않았다면 구매자의 청약 철회 등이
                제한되지 않습니다.
                <div />④ 구매자는 제1항 및 제2항에도 불구하고 재화 등의 내용이 표시·광고의 내용과 다르거나 계약내용과
                다르게 이행된 경우에는 그 재화 등을 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터
                30일 이내에 청약철회 등을 할 수 있습니다.
                <div />⑤ 가드너스클럽은 구매자로부터 교환 또는 반품의 의사표시를 받은 경우에는 즉시 그 사실을 파트너에게
                통보 합니다.
                <div />⑥ 구매자는 제1항 또는 제4항에 따라 교환신청을 하더라도 파트너에게 교환할 재화 등의 재고가 없는
                경우에는 해당 재화 등의 교환을 받을 수 없습니다. 이 경우 해당 교환신청은 반품으로 처리됩니다.
                <div />⑦ 반품이나 교환에 필요한 배송비 및 기타 비용은 귀책사유가 있는 당사자가 부담합니다. 재화 등의
                하자 또는 오배송으로 인한 반품이나 교환의 경우에는 파트너가 그 비용을 부담하지만, 구매자의 단순 변심으로
                인한 반품이나 교환의 경우에는 구매자가 그 비용을 부담하오니 유의하여 주시기 바랍니다.
                <div />⑧ 파트너는 구매자가 배송상의 문제로 손해를 입은 경우에는 그에 대한 책임을 부담합니다.
                <div />⑨ 가드너스클럽은 파트너가 구매자의 결제완료 통지를 받은 이후에도 상당 기간 배송 절차 등을
                이행하지 아니하여 구매자가 청약철회 등을 하거나 개별적인 정책으로 미리 정한 자동환불처리 사안에
                해당하는 경우에는 해당 거래를 취소하고 이용 중인 결제대금예치서비스를 통해 이용자에게 결제대금을 환불할
                수 있습니다.
                <div />
                ⑩구매자가 교환 또는 반품신청을 한 날로부터 14일이 지날 때까지 이미 수령한 재화 등을 파트너에게 반환하지
                아니하거나 전화, 이메일 등으로 연락이 되지 아니하는 경우에는 해당 구매자의 교환 또는 반품신청은 효력을
                상실합니다.
                <div />⑪ 파트너가 청약철회 등으로 인하여 결제대금을 환불하는 경우에는 그 청약철회 등을 한 날(단, 재화
                등이 배송된 경우에는 파트너가 재화 등을 반환 받은 날)로부터 3영업일 이내에 파트너는 환불에 필요한
                조치를 합니다. 신용카드로 결제가 이루어진 경우 환불은 해당 신용카드 결제 취소를 통해서만 가능하고,
                어떠한 경우에도 현금으로 환불되지 않습니다.
            </span>
            <h3>제20조(대리 및 보증의 부인)</h3>
            <span>
                : 가드너스클럽은 통신판매중개자로서 효율적인 서비스를 위한 시스템 운영 및 관리 책임만을 부담하며, 재화
                또는 용역의 거래와 관련하여 이용자 또는 파트너를 대리 및 보증하지 아니하고, 이용자와 파트너 사이에
                성립된 거래 및 파트너가 제공하고 등록한 정보에 대해서는 거래 당사자가 그에 대한 직접적인 책임을
                부담하여야 합니다.
            </span>
            <h3>제21조(통신판매자로서의 책임)</h3>
            <span>
                : 회사가 직접 이용자에게 재화 등을 판매하는 경우, 회사는 통신판매의 당사자로서 책임을 부담하며, 이 경우
                회사는 본 약관 제16조 내지 제20조 및 제27조의 파트너로 간주되어 이용자에게 동 약관에 따른 책임을 부담합
                니다.
            </span>
            <h3>제2절 커뮤니티</h3>
            <h3>제22조(콘텐츠 운영)</h3>
            <span>
                ① 가드너스클럽은 회원이 다음 각 호에 해당한다고 판단되는 콘텐츠를 등록하였을 경우 부적절한 콘텐츠로 판
                단하고 이를 삭제하거나 게시를 중단할 수 있습니다.
                <div />
                <StyledPrivacyContent>
                    1. 가드너스클럽, 이용자 또는 제3자를 비난하거나 명예를 훼손시키는 경우
                    <div />
                    2. 가드너스클럽의 이용목적에 부합하지 않거나 해당 서비스의 취지와 무관한 콘텐츠
                    <div />
                    3. 타인의 저작권, 상표권 등을 침해하는 콘텐츠
                    <div />
                    4. 음란성 콘텐츠와 혐오성 콘텐츠
                    <div />
                    5. 특정인의 개인정보가 포함된 콘텐츠
                    <div />
                    6. 특정 단어 또는 문구를 반복 산입하는 등의 비정상적인 콘텐츠 또는 프로그램 등을 이용하여 기계적인
                    패턴 글로 도배하는 경우
                    <div />
                    7. 회사가 허용하지 아니한 영리활동과 관련된 콘텐츠
                    <div />
                    8. 악성코드나 스파이웨어 등이 실행되어 다른 이용자, 파트너 기타 제3자의 시스템 성능 저하, 개인정보
                    유출 등의 피해를 줄 수 있는 악의적인 코드를 담고 있는 콘텐츠
                    <div />
                    9. 기타 관련법령 및 가드너스클럽 서비스 별 개별약관 등에 위반된다고 판단되는 경우
                </StyledPrivacyContent>
                <div />② 회원의 콘텐츠가 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』,『개인정보 보호법』 및
                『저작권법』 등 기타 법령에 위반되는 내용을 포함하는 경우, 권리자는 관련법령이 정한 절차에 따라 해당
                콘텐츠의 게시중단 및 삭제 등을 요청할 수 있으며, 가드너스클럽은 관련법령에 따라 권리자의 지식재산권을
                보호하기 위해 필요한 조치를 취할 수 있습니다.
            </span>
            <h3>제23조(콘텐츠의 저작권 등)</h3>
            <span>
                ① 회원이 가드너스클럽 내에 게시한 콘텐츠의 저작권을 포함한 지식재산권은 회원이 보유하며, 가드너스클럽이
                작성한 콘텐츠에 대한 저작권을 포함한 지식재산권은 가드너스클럽이 보유합니다.
                <div />② 가드너스클럽은 회원과 타인의 지식재산권이 서로 존중되고 보호받을 수 있도록 노력할 책임이 있고,
                특히 타인에 의해 회원의 지식재산권 침해가 확인될 경우 즉시 회원의 권리 보호를 위하여 필요한 조치를
                취하고 이를 회원에게 통지하는 등 가드너스클럽에 회원이 게시한 콘텐츠의 보호를 위하여 최선을
                다하겠습니다.
                <div />③ 회원의 가드너스클럽 내 콘텐츠 게시는, 다음 각 호의 사항을 허락한 것으로 간주합니다.
                <div />
                <StyledPrivacyContent>
                    1. 다른 회원의 동 콘텐츠 사용
                    <div />
                    2. 회사가 동 콘텐츠를 검색결과로 사용
                </StyledPrivacyContent>
                <div />④ 회원은 본인이 가드너스클럽 내에 게시한 콘텐츠를 회사가 국내 또는 국외에서 다음 각 호의 목적에
                따라 필요한 범위 내에서 해당 콘텐츠를 편집(수정, 복제, 배포 등을 의미하여 이에 한정하지 아니함) 및
                사용하는 것을 허락합니다.
                <div />
                <StyledPrivacyContent>
                    1. 서비스 내에서 콘텐츠를 사용하거나, 서비스를 홍보하기 위한 목적으로 인터넷, 모바일, SNS를 포함한
                    디지털 마케팅 채널 및 통신사 등에게 콘텐츠의 내용을 보도, 방영하는 경우
                    <div />
                    2. 콘텐츠를 복제ᆞ전송ᆞ전시하는 방법으로 제휴서비스에서 콘텐츠를 제공하는 경우
                </StyledPrivacyContent>
                <div />⑤ 제4항에도 불구하고 회원은 언제든지 가드너스클럽 고객센터 또는 가드너스클럽이 안내하는 경로를
                통하여 자신이 게시한 콘텐츠에 대한 삭제, 비공개, 사용중단 등을 요청할 수 있고, 가드너스클럽은 본 약관
                제8조에 정한 방법으로 회원에게 콘텐츠의 사용 내용을 공지할 수 있습니다.
                <div />⑥ 회원은 본인이 게시한 콘텐츠가 본 약관 제22조에 위반되지 아니함을 보증합니다. 회원이 작성한
                콘텐츠가 본 약관 제22조 및 관련법령을 위반한 경우 가드너스클럽의 귀책사유가 없는 한 회원은 그로 인한
                모든 책임을 부담한다는 점을 유의하여 주시기 바랍니다.
                <div />⑦ 본 약관 제11조에 따라 회원을 탈퇴하는 경우 회원이 가드너스클럽 내에 게시한 콘텐츠는 삭제됩니다.
                다만, 회원이 탈퇴하기 이전에 허용하였던 스크랩, 공유, 댓글 등과 같은 콘텐츠 이용이나 서비스의 운영에
                따라 필요하거나 법률에서 요구되는 경우에는 예외적으로 삭제되지 않을 수 있습니다.
                <div />⑧ 이용자는 서비스를 이용함으로써 얻은 정보 중 가드너스클럽이 지식재산권을 보유한 정보를
                가드너스클럽의 사전 승낙 없이 영리목적으로 이용하거나 제3자가 이용하게 하여서는 아니됩니다.
            </span>
            <h3>제4장 기타</h3>
            <h3>제24조(분쟁해결)</h3>
            <span>
                : 가드너스클럽은 이용자와 파트너 사이에 분쟁이 발생하지 않도록 최선을 다할 것입니다. 그럼에도 불구하고
                서비스 이용과 관련하여 분쟁이 발생할 경우 이는 거래당사자인 이용자와 파트너가 해결하여야 함을 유의하여
                주시기 바랍니다. 다만, 가드너스클럽은 가능한 한 최선의 노력을 다하여 거래당사자 간의 분쟁이 신속하게
                처리될 수 있도록 성실하게 협조할 것입니다.
            </span>
            <h3>제25조(준거법 및 관할법원)</h3>
            <span>
                ① 본 약관 또는 서비스는 대한민국의 법률에 따라 규정되고 이행됩니다.
                <div />② 본 약관 또는 서비스와 관련된 분쟁은 『민사소송법』상의 관할법원에 소를 제기할 수 있습니다.
            </span>
            <h3>부칙</h3>
            <span>: 본 약관은 2023년 3월 8일부터 시행합니다.<div /></span>
        </StyledPrivacyContainer>
    );
};

const StyledPrivacyContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    margin-top: 10px;
    min-width: 1140px;
    padding-left: 20%;
    padding-right: 20%;

    div {
        padding-bottom: 10px;
    }
`;

const StyledPrivacyContent = styled.div`
    padding-left: 30px;
`;
export default Tos;